import styled from "styled-components";

export const ModalWrapper = styled("div")`
  height: 100%;
  .close {
    cursor: pointer;
    position: absolute;
    top: -20px;
    right: -20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    background-color: #333;
    border-radius: 50%;
    outline: none;
    border: 0;
    svg {
      font-size: 20px;
      fill: #fff;
    }
  }
`;
